import routerPath from '@/router/routerPath'
import menuId from '@/constants/menuId'

const menus = [
  { 
    title: '서비스소개',
    link: routerPath.INTRODUCE,
    menuId: menuId.INTRODUCE,
  },
  // {
  //   title: '가격안내',
  //   link: routerPath.COST_INFO,
  //   menuId: menuId.COST_INFO,
  // },
  {
    title: '파트너사',
    link: routerPath.PARTNER,
    menuId: menuId.PARTNER,
  },
  { 
    title: '문의하기',
    link: routerPath.INQUIRE,
    menuId: menuId.INQUIRE,
  },
  { 
    title: '공지사항',
    link: routerPath.NOTICE_LIST,
    menuId: menuId.NOTICE,
  },
]

export { menus }